import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import MenuItem from '@material-ui/core/MenuItem'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import Table from '@ui/Table'

import DeleteMeasureDialog from './DeleteMeasureDialog'
import indexStyles from '@styles/indexPage'

// Rotulo amigavel da variavel; cai no proprio codigo quando nao ha traducao.
const variableLabel = name =>
  I18n.t(`v4/equipment_measures.variables.${name}`, { defaultValue: name })

class Index extends Component {
  constructor (props) {
    super(props)

    const { model } = props

    this.state = {
      isDialogOpen: false,
      id: null,
      equipment_id: (model.equipment && model.equipment.id) || '',
      variable: model.variable,
      start_date: model.start_date,
      end_date: model.end_date
    }

    this.closeDialog = this.closeDialog.bind(this)
    this.search = this.search.bind(this)
  }

  closeDialog () {
    this.setState({ isDialogOpen: false })
  }

  handleChange = field => event => {
    this.setState({ [field]: event.target.value })
  }

  indexUrl () {
    const { o } = this.props
    const { equipment_id, variable, start_date, end_date } = this.state

    const query = [
      `equipment_id=${encodeURIComponent(equipment_id)}`,
      `variable=${encodeURIComponent(variable)}`,
      `start_date=${encodeURIComponent(start_date)}`,
      `end_date=${encodeURIComponent(end_date)}`
    ].join('&')

    return `/v4/o/${o}/admin/equipment_measures?${query}`
  }

  search () {
    Turbolinks.visit(this.indexUrl())
  }

  render () {
    const { model, classes, o } = this.props
    const { isDialogOpen, id, equipment_id, variable, start_date, end_date } = this.state

    return (
      <Paper className={classes.page__wrapper} elevation={0}>
        <header className={classes.page__header}>
          <Typography component='h2' variant='h5'>
            {I18n.t('v4/equipment_measures.index.title')}
          </Typography>
        </header>

        <div className={classes.filters}>
          <TextField
            className={classes.filter}
            label={I18n.t('v4/equipment_measures.filters.equipment_id')}
            value={equipment_id}
            onChange={this.handleChange('equipment_id')}
            InputLabelProps={{ shrink: true }}
            variant='outlined'
            inputProps={{ 'data-testid': 'filter-equipment-id' }}
          />
          <TextField
            className={classes.filter}
            select
            label={I18n.t('v4/equipment_measures.filters.variable')}
            value={variable}
            onChange={this.handleChange('variable')}
            InputLabelProps={{ shrink: true }}
            variant='outlined'
          >
            {model.variables.map(name => (
              <MenuItem key={name} value={name}>{variableLabel(name)}</MenuItem>
            ))}
          </TextField>
          <TextField
            className={classes.filter}
            type='date'
            label={I18n.t('v4/equipment_measures.filters.start_date')}
            value={start_date}
            onChange={this.handleChange('start_date')}
            InputLabelProps={{ shrink: true }}
            variant='outlined'
          />
          <TextField
            className={classes.filter}
            type='date'
            label={I18n.t('v4/equipment_measures.filters.end_date')}
            value={end_date}
            onChange={this.handleChange('end_date')}
            InputLabelProps={{ shrink: true }}
            variant='outlined'
          />
          <Button
            variant='contained'
            color='primary'
            onClick={this.search}
            data-testid='search-measures'
          >
            {I18n.t('v4/equipment_measures.filters.search')}
          </Button>
        </div>

        <div className={classes.actions}>
          <Button
            variant='outlined'
            color='primary'
            href={`/v4/o/${o}/admin/equipment_measures/new?equipment_id=${equipment_id}&variable=${variable}`}
          >
            {I18n.t('v4/equipment_measures.index.create')}
          </Button>
          <Button
            variant='outlined'
            href={`/v4/o/${o}/admin/equipment_measures/audits`}
          >
            {I18n.t('v4/equipment_measures.index.audits')}
          </Button>
        </div>

        {model.equipment &&
          <Typography variant='subtitle1' className={classes.equipment}>
            {model.equipment.name} — {model.variable}
          </Typography>
        }

        <Table
          tableKey='admin-equipmentMeasures-index'
          components={{
            Container: props => <div>{props.children}</div>
          }}
          columns={[
            { title: I18n.t('v4/equipment_measures.table.measured_at'), field: 'measured_at' },
            { title: I18n.t('v4/equipment_measures.table.value'), field: 'value' }
          ]}
          data={model.measures}
          actions={[
            rowData => ({
              icon: 'create',
              iconProps: { 'data-testid': `edit-${rowData['id']}` },
              tooltip: I18n.t('v4/equipment_measures.index.tooltip_edit'),
              onClick: (event, rowData) => {
                Turbolinks.visit(`/v4/o/${o}/admin/equipment_measures/${rowData['id']}/edit?variable=${variable}`)
              }
            }),
            rowData => ({
              icon: 'delete',
              iconProps: { 'data-testid': `delete-${rowData['id']}` },
              tooltip: I18n.t('v4/equipment_measures.index.tooltip_remove'),
              onClick: (event, rowData) => {
                this.setState({ isDialogOpen: true, id: rowData['id'] })
              }
            })
          ]}
          options={{
            showTitle: false
          }}
        />

        <DeleteMeasureDialog
          successUrl={this.indexUrl()}
          deleteUrl={`/v4/o/${o}/admin/equipment_measures/${id}.json?variable=${variable}`}
          onCancel={this.closeDialog}
          open={isDialogOpen}
        />
      </Paper>
    )
  }
}

Index.propTypes = {
  model: PropTypes.shape({
    measures: PropTypes.array,
    variables: PropTypes.array,
    variable: PropTypes.string
  })
}

Index.defaultProps = {
  model: { measures: [], variables: [], variable: 'pl1', start_date: '', end_date: '' }
}

const Styles = theme => ({
  ...indexStyles(theme),
  filters: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: `${theme.spacing.unit * 2}px`,
    marginBottom: theme.spacing.unit * 2
  },
  filter: {
    marginRight: theme.spacing.unit * 2,
    minWidth: 160
  },
  actions: {
    display: 'flex',
    gap: `${theme.spacing.unit}px`,
    marginBottom: theme.spacing.unit * 2
  },
  equipment: {
    marginBottom: theme.spacing.unit * 2
  }
})

export default withStyles(Styles)(Index)
